var page = promokit.page({
    game: 'lineage',

    cnb: true,

    headerButton: {
        el: '.header-button',
        sns: true,
        home: true,
        event: true
    },

    topButton: '.section-1',

    footer: {
        theme: 'black'
    },

    caution: '#section-7'
});

// 레이어 1
var layer1 = promokit.layer({
    el: '#layer-1',
    buttons: '.vote-layer-btn'
});
$(document).on('click', '.vote-layer-btn', function() {
    layer1.open();
});

// 레이어 2
var layer2 = promokit.layer({
    el: '#layer-2',
    buttons: '.point-layer-btn'
});
$(document).on('click', '.point-layer-btn', function() {
    layer2.open();
});

// 탭
class Tab{
    constructor(box) {
        this.$box = $(box);
        this.$btn = this.$box.find('.tab-btn');
        this.$cont = this.$box.find('.tab-cont');

        this.init();
    }

    init() {
        this.bindEvent();
    }

    action(t) {
        let tabID = $(t).data().tab;
        this.$btn.removeClass('active');
        $(t).addClass('active');
        this.$cont.hide();
        this.$cont.each( (idx,elem) => $(elem).data().tabCont == tabID ? $(elem).show() : '' );
    }

    bindEvent() {
        this.$btn.on('click', (e)=>{ this.action(e.target) } );
    }
}
var tab = new Tab('.tab-blood');

// 캐릭터선택
var selectWrap = $('.select-wrap');
$(selectWrap).on('click', (e)=>{
    if(e.target.tagName == 'BUTTON') return true;

    if($(e.target).parent().hasClass($(selectWrap).attr('class'))){
        $('.select-list', selectWrap).toggle();
    } else {
        $('.select-list', selectWrap).hide();
        $('a:eq(0)', selectWrap)
            .html($(e.target).text())
            .attr({
                'data-serverId': $(e.target).attr('data-serverId'),
                'data-charId': $(e.target).attr('data-charId')
            });
    }
    e.preventDefault();
});

// 로그인버튼
$(document).on('click', '.login-btn', function(){
    promokit.login();
});


// WEBPACK FOOTER //
// ./src/js/legend.js